import React, { useState } from 'react';

async function getRecommendations(messages) {
    const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
    const modelId = 'ft:gpt-4o-2024-08-06:personal:newbeta:A3oZJpl9'; // Use fine-tuned model ID

    try {
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiKey}`
            },
            body: JSON.stringify({
                model: modelId,
                messages: messages,
                max_tokens: 500,
                temperature: 0.7,
                n: 1,
                stop: null
            })
        });

        if (!response.ok) 
        {
            throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();

        if (!data.choices || !data.choices.length) 
        {
            throw new Error('No recommendations found in the API response.');
        }

        return data.choices[0].message.content;
    } catch (error) {
        console.error('Error fetching recommendations:', error);
        return 'There was an error fetching the recommendations. Please try again later.';
    }
}

function AIAssistant({ onClose }) 
{
    const [userInput, setUserInput] = useState('');
    const [chatHistory, setChatHistory] = useState([
        { role: 'system', content: 'You are a helpful assistant. You help with recommending the best Proteus products.' }
    ]);
    const [displayText, setDisplayText] = useState(''); 

    const handleInputChange = (e) => {
        setUserInput(e.target.value);
    };

    const handleGetQuote = async () => {
        if (userInput.trim() === '') return;

        const userMessage = { role: 'user', content: userInput };
        const updatedChatHistory = [...chatHistory, userMessage];

        setChatHistory(updatedChatHistory);

        const recommendation = await getRecommendations(updatedChatHistory);
        const assistantMessage = { role: 'assistant', content: recommendation };
        const finalChatHistory = [...updatedChatHistory, assistantMessage];

        setChatHistory(finalChatHistory);

        // Update display text
        const chatDisplayText = finalChatHistory
            .filter(msg => msg.role !== 'system') 
            .map(msg => `${msg.role === 'user' ? 'You' : 'Assistant'}: ${msg.content}`)
            .join('\n');

        setDisplayText(chatDisplayText);
        setUserInput(''); 
    };

    return (
        <div className="ai-assistant">
            <div className="modal-content">
                <h2>AI Powered Proteus Assistant</h2>
                <textarea
                    placeholder="Chat history will be displayed here..."
                    value={displayText}
                    readOnly
                    rows={10}
                    style={{ width: '100%', marginBottom: '10px' }}
                />
                <input
                    type="text"
                    placeholder="Enter your question..."
                    value={userInput}
                    onChange={handleInputChange}
                    style={{ width: '100%', marginBottom: '10px' }}
                />
                <button onClick={handleGetQuote}>Ask!</button>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
}

export default AIAssistant;
